import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f016500"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt_10" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "rate flex-ter rel" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "rate flex-ter rel" }
const _hoisted_6 = { class: "rel flex-ter" }

import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import { ElMessage } from 'element-plus'
import { getCustomerShopShipListApi, getShopLogistics, addConfigShopShipApi, editConfigShopShipApi } from '@/apis/setup'
import { getCustomerShop } from '@/apis/order'
import { throughCountryGetExpressApi } from '@/apis/user'
import { getWarehouseCode, isJA } from '@/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const expresses: any = ref([])
const showShipConfig = ref(false)
const intShipConfigId = ref()
throughCountryGetExpressApi({
  countryCode: isJA() ? 'JP' : 'UK',
  warehouseCode: getWarehouseCode(false)
}).then((res) => {
  expresses.value = res.data
}).then(getShopLogistics)
  .then(async (res) => {
    if (res.data?.addressAdditionRespDTO) {
      const { data: expressList }: any = await getCustomerShopShipListApi({ warehouseCode: getWarehouseCode(false) })
      showShipConfig.value = expressList.length === 0
    }
  })

const expressItem:any = ref({})
const isAdd = ref(true)
const update = () => {
  const api = isAdd.value ? addConfigShopShipApi : editConfigShopShipApi
  const params:any = {
    countryCode: isJA() ? 'JP' : 'UK',
    warehouseCode: getWarehouseCode(false),
    logisticsId: intShipConfigId.value
  }
  if (!isAdd.value) {
    params.customerShopShipId = expressItem.value.customerShopShipId
  }
  api(params).then(async (res) => {
    if (res.success) {
      isAdd.value = false
      ElMessage.success(t('修改成功'))
      const { data: expressList }: any = await getCustomerShopShipListApi({ warehouseCode: getWarehouseCode(false) })
      expressItem.value = expressList.find((v:{countryCode: string}) => v.countryCode === (isJA() ? 'JP' : 'UK'))
    }
  })
}
const wareName = ref('')
getCustomerShop().then((res: any) => {
  if (res.success) {
    const warehouseList = res.data?.warehouseList ?? []
    // 表结构变了，换种形式获取仓库名称
    wareName.value = warehouseList.find((item:{warehouseCountry:string}) => item.warehouseCountry === 'CN')?.warehouseName
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showShipConfig.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)('店铺仓库所在地')), 1),
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(wareName.value) + ", ", 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('目的地国家')), 1),
              _createTextVNode("：" + _toDisplayString(_unref(isJA)() ? _unref(t)('日本') : 'UK'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)('选择物流公司')), 1),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_select, {
                modelValue: intShipConfigId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((intShipConfigId).value = $event)),
                onChange: update
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expresses.value, (v) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: v.intShipConfigId,
                      value: v.intShipConfigId,
                      label: v.distribution
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})